import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { ItemDetail } from '../../../types/item-detail';
import { IconComponent, CardComponent, BadgeComponent } from '@softline/ui-core';
import { SortPipe } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-details',
  imports: [
    CdkAccordionModule,
    CommonModule,
    IconComponent,
    SortPipe,
    TranslatePipe,
    CardComponent,
    BadgeComponent,
  ],
  templateUrl: './details.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Details {
  readonly data = input.required<ItemDetail | null>();
  readonly hideLagerplaetze = input.required<boolean>();
  readonly hideEinheiten = input.required<boolean>();
  readonly hideLieferanten = input.required<boolean>();

  readonly lagerplaetzeExpanded = input.required<boolean>();
  readonly einheitenExpanded = input.required<boolean>();
  readonly lieferantenExpanded = input.required<boolean>();
}
